import {
  Button,
  Flex,
  Link,
  PlacementWithLogical,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { ProjectDocument } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function TwitterAccountToFollowList({
  project,
  tooltipPosition,
  isTooltipOpen,
}: {
  project: ProjectDocument;
  tooltipPosition?: PlacementWithLogical;
  isTooltipOpen: string;
}) {
  return project?.twitter?.enabled && project?.twitter?.isFollowRequired ? (
    <>
      {project?.twitter?.follow?.split(",").map((element: string) => (
        <Tooltip
          key={element}
          label={
            <>
              You must follow{" "}
              <Link
                target={"_blank"}
                href={`https://twitter.com/${element.trim()}`}
              >
                <b>@{element.trim()}</b>
              </Link>{" "}
              on Twitter
            </>
          }
          pointerEvents={"all"}
          isOpen={isTooltipOpen.includes(element.trim())}
          padding={4}
          fontSize={"md"}
          backgroundColor={"red.500"}
          placement={tooltipPosition}
          hasArrow
        >
          <Flex
            fontSize="13"
            color={"descText"}
            mb="2"
            direction={"row"}
            alignItems={"center"}
          >
            <Text>
              Follow <strong>@{element.trim()}</strong> on Twitter
            </Text>
            <RequiredIndicator required={!project.twitter?.isFollowOptional} />
            <Button
              as={Link}
              target={"_blank"}
              href={`https://twitter.com/${element.trim()}`}
              size={"xs"}
              _hover={{ textDecoration: "none" }}
              px={4}
              py={4}
              ml={"auto"}
              colorScheme={"gray"}
              fontWeight={400}
              rounded={"full"}
            >
              Follow
            </Button>
          </Flex>
        </Tooltip>
      ))}
    </>
  ) : null;
}
